import { CameraSharp, DeviceHub, Devices, PortraitSharp } from '@mui/icons-material';
import UpcomingIcon from '@mui/icons-material/Upcoming';
import Icon from '@mui/material/Icon';
import AlarmCentralPhysicalContextProvider from 'pages/AlarmCentralPages/context/AlarmCentralPhysicalContext';
import AlarmCentralVirtualContextProvider from 'pages/AlarmCentralPages/context/AlarmCentralVirtualContext';
import { lazy } from 'react';
import { Permissions } from 'services/enums';
import { DEFAULT_ROUTE, IRouteProps } from '../types';

const AlarmCentralManagementPhysicalPage = lazy(
	() => import('pages/AlarmCentralPages/AlarmCentralManagementPage/AlarmCentralManagementPhysicalPage'),
);
const AlarmCentralManagementVirtualPage = lazy(
	() => import('pages/AlarmCentralPages/AlarmCentralManagementPage/AlarmCentralManagementVirtualPage'),
);
const AlarmCentralMainPage = lazy(() => import('pages/AlarmCentralPages/AlarmCentralMainPage'));
const CamsPage = lazy(() => import('pages/DevicesPages/CamsPage'));
const ControllersPage = lazy(() => import('pages/DevicesPages/ControllersPage'));
const DvrPage = lazy(() => import('pages/DevicesPages/DvrPage'));

export const deviceRoutes: IRouteProps[] = [
	{
		type: 'collapse',
		name: 'routersNames.devices',
		key: 'devices',
		permissionId: Permissions.DEVICES,
		icon: <Devices />,
		protected: true,
		collapse: [
			{
				type: 'collapse',
				name: 'routersNames.cams',
				key: 'cams',
				icon: <CameraSharp />,
				route: `${DEFAULT_ROUTE}/devices/camera`,
				permissionId: [Permissions.DEVICES],
				component: <CamsPage />,
				protected: true,
			},
			{
				type: 'collapse',
				name: 'routersNames.controllers',
				key: 'facialControl',
				icon: <PortraitSharp />,
				route: `${DEFAULT_ROUTE}/devices/facialControl`,
				permissionId: [Permissions.DEVICES],
				component: <ControllersPage />,
				protected: true,
			},
			{
				type: 'collapse',
				name: 'DVR/NVR/NVD',
				key: 'dvr',
				icon: <DeviceHub />,
				route: `${DEFAULT_ROUTE}/devices/dvr`,
				permissionId: [Permissions.DEVICES],
				component: <DvrPage />,
				protected: true,
			},
			{
				type: 'collapse',
				name: 'routersNames.centralAlarms',
				key: 'alarmCentral',
				route: `${DEFAULT_ROUTE}/alarmCentral`,
				icon: <UpcomingIcon />,
				permissionId: [Permissions.ALARM_CENTRAL],
				protected: true,
				component: <AlarmCentralMainPage />,
			},
		],
	},
	{
		key: 'alarmCentralPhysicalDetails',
		icon: <Icon fontSize="small">bell</Icon>,
		route: `${DEFAULT_ROUTE}/alarmCentral/physical/:id`,
		permissionId: Permissions.ALARM_CENTRAL,
		component: (
			<AlarmCentralPhysicalContextProvider>
				<AlarmCentralManagementPhysicalPage />
			</AlarmCentralPhysicalContextProvider>
		),
		protected: false,
	},
	{
		key: 'alarmCentralVirtualDetails',
		icon: <Icon fontSize="small">bell</Icon>,
		route: `${DEFAULT_ROUTE}/alarmCentral/virtual/:id`,
		permissionId: Permissions.ALARM_CENTRAL,
		component: (
			<AlarmCentralVirtualContextProvider>
				<AlarmCentralManagementVirtualPage />
			</AlarmCentralVirtualContextProvider>
		),
		protected: false,
	},
];
